export default __webpack_public_path__ + "static/media/1582.7252644e.png";